import { render, staticRenderFns } from "./AboutStory.vue?vue&type=template&id=d2da9fa8&scoped=true"
import script from "./AboutStory.vue?vue&type=script&lang=js"
export * from "./AboutStory.vue?vue&type=script&lang=js"
import style0 from "./AboutStory.vue?vue&type=style&index=0&id=d2da9fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2da9fa8",
  null
  
)

export default component.exports